function requireAll( r ) { r.keys().forEach( r ); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/ ) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/ ) );
//requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );

import $ from 'jquery';
import ScrollReveal from 'scrollreveal';

let gMapsLoading = false;
let gMapsLoaded  = false;

window.gMapsCallback = function() {

	gMapsLoaded = true;
	$( window ).trigger( 'gMapsLoaded' );

};

window.jQuery = $;
window.$      = $;

$( function() {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if ( typeof window.innerWidth !== 'undefined' ) {

					viewPortWidth  = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
					typeof document.documentElement.clientWidth !== 'undefined' &&
					document.documentElement.clientWidth !== 0 ) {

					viewPortWidth  = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth  = document.getElementsByTagName( 'body' )[ 0 ].clientWidth;
					viewPortHeight = document.getElementsByTagName( 'body' )[ 0 ].clientHeight;
				}

				return { width: viewPortWidth, height: viewPortHeight };

			},

			init: function() {

				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.list.init();

				PROJECT.header.init();

				PROJECT.scrollAnimations.init();

				PROJECT.gform.init();

				PROJECT.map.init();

			}

		},

		header: {

			scrolledClass: 'state-c-header--scrolled',
			lastScrollTop: 0,
			scrollThreshold: 4,
			ticking: false,

			init: function() {
				window.addEventListener( 'scroll', PROJECT.header.scroll, { passive: true } );
				PROJECT.header.scroll();
			},

			scroll: function() {

				if ( PROJECT.header.ticking ) return;

				PROJECT.header.ticking = true;

				requestAnimationFrame( function() {

					let scrollTop        = window.scrollY || window.pageYOffset;
					let scrollDifference = Math.abs( scrollTop - PROJECT.header.lastScrollTop );

					if ( scrollDifference >= PROJECT.header.scrollThreshold ) {

						let isScrollingDown     = scrollTop > PROJECT.header.lastScrollTop && scrollTop > 0;
						let isCurrentlyScrolled = document.documentElement.classList.contains( PROJECT.header.scrolledClass );

						if ( isScrollingDown && !isCurrentlyScrolled ) {

							$( 'html' ).addClass( PROJECT.header.scrolledClass );

						} else if ( !isScrollingDown && isCurrentlyScrolled ) {

							$( 'html' ).removeClass( PROJECT.header.scrolledClass );
						}

						PROJECT.header.lastScrollTop = scrollTop;
					}

					PROJECT.header.ticking = false;

				} );

			}
		},

		toggle: {

			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {

				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );

			},

			switch: function( e ) {

				let $elm = $( this );

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );

			}

		},

		nav: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */


			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-header--nav-open',

			init: function() {

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );

				$( document ).on( 'keyup', PROJECT.nav.esc );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr( 'tabindex', -1 );

				} );

			},

			toggle: function() {

				if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {

					PROJECT.nav.close();

				} else {

					PROJECT.nav.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.nav.close();

				}
			},

			open: function() {

				$( 'html' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).removeAttr( 'tabindex', -1 );

				} );

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr( 'tabindex', -1 );

				} );

			}

		},

		scrollAnimations: {

			init: function() {

				PROJECT.scrollAnimations.scrollReveal();

			},

			scrollReveal: function() {

				PROJECT.scrollAnimations.sr = new ScrollReveal( {

					scale: 1,
					viewFactor: 0.25,
					duration: 400,
					delay: 250,
					distance: '50px',
					easing: 'ease-out',
					opacity: 0

				} );

				PROJECT.scrollAnimations.sr.reveal( '.jsRevealFromBottom' );

				PROJECT.scrollAnimations.sr.reveal( '.jsRevealFromBottomBlocks', {

					interval: 200

				} );

				PROJECT.scrollAnimations.sr.reveal( '.c-main .wysiwyg > *' );

			}

		},

		gform: {
			init: function() {
				$(document).on('gform_post_render', function() {
					PROJECT.gform.hideLoader();
					PROJECT.gform.fixHasFocus();
				});

				$(document).on('click.loader', '.gform_button', PROJECT.gform.showLoader);
				$(document).on('click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader);
				$(document).on('submit', '.gform_wrapper form', PROJECT.gform.showLoader);

				$(document).on('gform_page_loaded', function() {
					PROJECT.gform.hideLoader();
					PROJECT.gform.fixHasFocus();
				});

				$(document).on('gform_confirmation_loaded', PROJECT.gform.showConfirmation);
				$(document).on('click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation);

				$(document).on('focus', 'input, textarea, select', function() {
					$(this)
						.parents('.gfield')
						.addClass('state--has-focus');
				});

				$(document).on('blur', 'input, textarea, select', function(e) {
					if (!$(this).val()) {
						$(this)
							.parents('.gfield')
							.removeClass('state--has-focus');
					}
				});

				// Check for values on input change
				$(document).on('input change', 'input, textarea, select', function() {
					var $field = $(this).parents('.gfield');
					if (
						$(this)
							.val()
							.trim() !== ''
					) {
						$field.addClass('gfield--has-value');
					} else {
						$field.removeClass('gfield--has-value');
					}
				});

				PROJECT.gform.fixHasFocus();
			},

			fixHasFocus: function() {
				$('input, textarea, select').each(function() {
					var $field = $(this).parents('.gfield');

					if ($(this).val()) {
						$field.addClass('state--has-focus');
						$field.addClass('gfield--has-value');
					} else {
						$field.removeClass('gfield--has-value');
					}
				});
			},

			showLoader: function() {
				var $gformContainer = $(this).closest('.gformContainer');
				var $gformLoader = $gformContainer.find('.gformLoader');

				$gformLoader.fadeIn(300).css('display', 'flex');
			},

			hideLoader: function() {
				$('.gformLoader').fadeOut(300);
			},

			showConfirmation: function() {
				$('.gformConfirmation')
					.fadeIn(300)
					.css('display', 'flex');
			},

			hideConfirmation: function() {
				$('.gformConfirmation').fadeOut(300);
			},
		},

		list: {

			// Only for project based code.
			init: function() {}

		},

		map: {
			init: function() {

				if ( $( '.gMap' ).length > 0 ) {

					$( window ).on( 'gMapsLoaded', PROJECT.map.loadMarker );

					var googleMapApiKey = $( '.gMap' ).data( 'key' );

					// Init maps after tscookiesLoaded event
					document.addEventListener( 'tscookiesLoaded', function() {

						//PROJECT.map.maps();
						PROJECT.map.load( googleMapApiKey );

					} );

					// Init maps after tscookiesSetConsent event
					document.addEventListener( 'tscookiesSetConsent', function() {

						//PROJECT.map.maps();
						PROJECT.map.load( googleMapApiKey );

					} );

				}

			},

			load: function( googleMapApiKey ) {

				if ( gMapsLoaded ) return window.gMapsCallback();

				if ( typeof window.TSCOOKIE !== 'undefined' && typeof window.TSCOOKIE.cookie.marketing !== 'undefined' && window.TSCOOKIE.cookie.marketing ) {

					if ( !gMapsLoading ) {

						gMapsLoading = true;

						var script_tag = document.createElement( 'script' );

						script_tag.setAttribute( "src", "https://maps.googleapis.com/maps/api/js?loading=async&key=" + googleMapApiKey + "&libraries=maps,marker&callback=gMapsCallback" );

						(document.getElementsByTagName( "head" )[ 0 ] || document.documentElement).appendChild( script_tag );

					}

				}

			},

			loadMarker: async function() {

				const [ { AdvancedMarkerElement } ] =
						  await Promise.all( [
							  google.maps.importLibrary( 'marker' ),
							  google.maps.importLibrary( 'maps' ),
						  ] );

				const mapElement = document.querySelector( "gmp-map" );
				const innerMap   = mapElement.innerMap;

				innerMap.setOptions( {
					mapTypeControl: false,
					streetViewControl: false,
					fullscreenControl: false,
				} );

				const parser = new DOMParser();

				// A marker with a custom inline SVG.
				const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="69" fill="none"><path fill="#ee7b2d" d="M57.868 59.816a3.77 3.77 0 0 0 3.768-3.768l.001-52.28A3.77 3.77 0 0 0 57.868 0h-54.1A3.77 3.77 0 0 0 0 3.768v52.279a3.77 3.77 0 0 0 3.768 3.769h12.609c2.081 0 4.979 1.175 6.472 2.624l5.265 5.109c1.494 1.45 3.915 1.45 5.408 0l5.265-5.109c1.494-1.449 4.392-2.624 6.473-2.624z"/><path fill="#fff" d="M39.523 29.197c4.795-1.11 7.465-3.913 7.465-8.354v-1.576c0-6.718-4.673-10.047-12.926-10.047H16.159c-.704 0-1.274.549-1.274 1.225v1.345c0 .613.516 1.11 1.153 1.11h4.309v3.365c0 .5.422.907.943.907h3.332c.52 0 .943-.407.943-.907V12.78h8.254c5.462 0 7.95 2.221 7.95 6.368v2.104c0 3.4-1.634 5.46-5.146 6.125-.453.084-.793.448-.793.893v2.153c0 .454.352.822.816.896 3.797.619 5.973 2.79 5.973 6.405v2.22c0 4.38-2.671 6.602-8.314 6.602h-8.74v-4.083c0-.502-.422-.907-.943-.907H21.29c-.521 0-.943.405-.943.907v3.965h-4.188c-.704 0-1.274.548-1.274 1.225v1.286c0 .646.543 1.169 1.213 1.169h18.449c8.497 0 13.29-3.447 13.29-10.28v-1.694c0-4.85-2.973-7.828-8.314-8.938"/><path fill="#fff" d="M31.285 26.722h-5.377v-5.175c0-.683-.443-1.196-1.153-1.196h-3.227c-.71 0-1.11.513-1.11 1.196v5.175h-5.376c-.71 0-1.242.427-1.242 1.11v3.106c0 .683.533 1.068 1.242 1.068h5.377v5.175c0 .683.443 1.196 1.154 1.196h3.226c.709 0 1.109-.513 1.109-1.196v-5.175h5.377c.709 0 1.242-.427 1.242-1.11V27.79c0-.683-.533-1.068-1.242-1.068"/></svg>';

				const pinSvg       = parser.parseFromString(
					pinSvgString,
					'image/svg+xml'
				).documentElement;
				const pinSvgMarker = new AdvancedMarkerElement( {
					position: innerMap.getCenter(),
					title: mapElement.dataset.title,
					anchorLeft: '-50%',
					anchorTop: '-50%',
				} );
				pinSvgMarker.append( pinSvg );
				mapElement.append( pinSvgMarker );
			}
		}
	};

	var UTIL = {

		exec: function( controller, action ) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if ( controller !== '' && ns[ controller ] && typeof ns[ controller ][ action ] === 'function' ) {

				ns[ controller ][ action ]();

			}

		},

		init: function() {

			var body       = document.body,
			    controller = body.getAttribute( 'data-controller' ),
			    action     = body.getAttribute( 'data-action' );

			UTIL.exec( 'common' );
			UTIL.exec( controller );
			UTIL.exec( controller, action );

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$( window ).ready( UTIL.init );

} );

